/* =========================
   IMPORTS (как у тебя)
========================= */
import tashkentTea from '@/assets/images/tashkent-tea.jpeg'
import karkadeTea from '@/assets/images/tea/karkade.png'

import veronaPizza from '@/assets/images/pizzas/mashroom.png'
import pepperoniPizza from '@/assets/images/pizzas/pepperoni.png'
import caesarPizza from '@/assets/images/pizzas/cesar.png'
import meatPizza from '@/assets/images/pizzas/meat.png'
import assortiPizza from '@/assets/images/pizzas/assorti.png'

import chocolateMilkshake from '@/assets/images/milkshakes/chocolate.png'
import pineappleMilkshake from '@/assets/images/milkshakes/pineapple.png'
import oreoMilkshake from '@/assets/images/milkshakes/oreo.png'
import strawberryMilkshake from '@/assets/images/milkshakes/strawberry.png'
import blackberryMilkshake from '@/assets/images/milkshakes/blackberry.png'
import snickersMilkshake from '@/assets/images/milkshakes/snickers.png'
import matchaMilkshake from '@/assets/images/milkshakes/matcha.png'

import fila from '@/assets/images/rolls/fila.png'
import filaUgor from '@/assets/images/rolls/fila-ugor.png'
import filaMiks from '@/assets/images/rolls/fila-miks.png'
import kaliforniaSalmon from '@/assets/images/rolls/kalifornia-salmon.png'
import chickenTempura from '@/assets/images/rolls/chickenTempura.png'
import salmonTempura from '@/assets/images/rolls/salmonTempura.png'
import krabTempura from '@/assets/images/rolls/krabTempura.png'
import kaliforniaTempura from '@/assets/images/rolls/kaliforniaTempura.png'
import chickenzap from '@/assets/images/rolls/chickenzap.png'
import fulkan from '@/assets/images/rolls/fulkan.png'
import chickenxrust from '@/assets/images/rolls/xrust.png'
import minisalmon from '@/assets/images/rolls/mini-salmon.png'
import miniunagi from '@/assets/images/rolls/mini-unagi.png'
import minicucumber from '@/assets/images/rolls/mini-cucumber.png'
import sushisalmon from '@/assets/images/rolls/sushi-salmon.png'
import sushiunagi from '@/assets/images/rolls/sushi-unagi.png'
import sweetChoco from '@/assets/images/rolls/sweet-choco.png'
import sweetBanana from '@/assets/images/rolls/sweet-banana.png'
import bakedSushi from '@/assets/images/rolls/baked-sushi.png'
import filaGril from '@/assets/images/rolls/fila-gril.png'





import kalifornia from '@/assets/images/rolls/kalifornia.png'


import salmonTomYamImg from '@/assets/images/soups/salmon.jpg'
import spicyRamen from '@/assets/images/soups/spicyRamen.png'
import chesseRamen from '@/assets/images/soups/cheeseRamen.png'

import strawberryBubble from '@/assets/images/bubble/strawberry.png'
import blackberryBubble from '@/assets/images/bubble/blackberry.png'
import caramelBubble from '@/assets/images/bubble/caramel.png'
import pineappleBubble from '@/assets/images/bubble/pineapple.png'

import garlic from '@/assets/images/garlicBread.jpeg'
import naggets from '@/assets/images/naggetsi.jpg'
import strips from '@/assets/images/strips.jpeg'
import wings from '@/assets/images/wings.jpeg'
import fri from '@/assets/images/fri.jpg'
import cheeseBalls from '@/assets/images/cheeseballs.png'
import potatoVillage from '@/assets/images/villagepotato.png'


import simpleTea from '@/assets/images/tea/simpleTea.jpeg'
import mintTea from '@/assets/images/tea/mintTea.jpeg'
import gingerTea from '@/assets/images/tea/gingerTea.jpeg'
import strawberryTea from '@/assets/images/tea/strawberryTea.jpeg'
import lemonTea from '@/assets/images/tea/lemonTea.jpeg'
import blackberryTea from '@/assets/images/tea/blackBerryTea.jpeg'
import pineappleTea from '@/assets/images/tea/pineappleTea.jpeg'


import sobaChicken from '@/assets/images/wok/sobaChicken.png'
import udonChicken from '@/assets/images/wok/udonChicken.jpg'
import udonSalmon from '@/assets/images/wok/udonSalmon.png'
import vegSoba from '@/assets/images/wok/vegSoba.png'
import udonVeg from '@/assets/images/wok/vegUdon.png'
import sobaSalmon from '@/assets/images/wok/salmpnSoba.png'


import mojitoClassic from '@/assets/images/bubble/mojito-classic.png'
import mojitoStrawberry from '@/assets/images/bubble/mojito-strawberry.png'
import mojitoPineapple from '@/assets/images/bubble/mojito-pineapple.png'
import mojitoBlackcurrant from '@/assets/images/bubble/mojito-blackcurrant.png'

import meat from '@/assets/images/fastfood/meat.png'
import chicken from '@/assets/images/fastfood/chicken.png'
import fish from '@/assets/images/fastfood/fish.png'
import shaurma from '@/assets/images/fastfood/shaurma.png'
import xotdog from '@/assets/images/fastfood/xotdog.png'
import shaurmaCheese from '@/assets/images/fastfood/shaurmaCheese.png'

import rojok from '@/assets/images/icecream/rojok.png'
import stakan from '@/assets/images/icecream/stakan.jpg'
import fruit from '@/assets/images/icecream/fruits.jpg'


import garlicSauces from '@/assets/images/sauces/garlic.png'
import cheese from '@/assets/images/sauces/сheese.png'
import barbecue from '@/assets/images/sauces/barbecue.png'
import ketchup from '@/assets/images/sauces/tomato.png'

import love from '@/assets/images/sets/love.png'
import dospizza from '@/assets/images/sets/dospizza.png'
import jara from '@/assets/images/sets/jara.png'
import malshish from '@/assets/images/sets/malshish.png'
import mix from '@/assets/images/sets/mix.png'
import nabor from '@/assets/images/sets/nabor.png'
import para from '@/assets/images/sets/para.png' // ✅ исправлено
import threepoems from '@/assets/images/sets/threepoems.png'



/* =========================
   CATEGORY TITLES
========================= */
export const categoryTitles = {
  rolls: "Роллы",
  pizza: "Пиццы",
  pasta: "Пасты",
  wok: "WOK",
  snacks: "Снеки",
  fastfood: "Фастфуд",
  icecream: "Мороженое", // 👈 добавлено
  milkshakes: "Милкшейки",
  tea: "Чаи",
  sauces: "Соусы",
  sets: "Сеты",
  salats: "Салаты",
  drinks: "Напитки",
  coffee: "Кофе",
}

/* =========================
   PRODUCT DATA (все твои данные)
   + добавил uid (уникальный ключ)
========================= */
export const productData = {
sauces: [
  { uid: "sauce-1", id: 1, name: "Сырный соус", price: 30, image: cheese },
  { uid: "sauce-2", id: 2, name: "Чесночный соус", price: 30, image: garlicSauces },
  { uid: "sauce-3", id: 3, name: "Кетчуп", price: 30, image: ketchup },
  { uid: "sauce-4", id: 4, name: "Барбекю", price: 30, image: barbecue },
],
fastfood: [
  {
    uid: "fastfood-1",
    id: 1,
    name: "Хот-дог",
    price: 120,
    image: xotdog,
    description: "Булочка с куриной сосиской, свежими овощами и соусами (белый соус и кетчуп)"
  },
  {
    uid: "fastfood-2",
    id: 2,
    name: "Бургер классический",
    price: 180,
    image: meat,
    description: "Сочный говяжий бургер с овощами и фирменными соусами в мягкой булочке"
  },
  {
    uid: "fastfood-3",
    id: 3,
    name: "Чиккен бургер",
    price: 250,
    image: chicken,
    description: "Бургер с куриным филе, сыром чеддер, свежими овощами и сырно-чесночным соусом"
  },
  {
    uid: "fastfood-4",
    id: 4,
    name: "Фиш бургер",
    price: 280,
    image: fish,
    description: "Бургер с рыбной котлетой, сыром чеддер, овощами и соусами барбекю и сырным"
  },
  {
    uid: "fastfood-5",
    id: 5,
    name: "Шаурма классическая",
    price: 220,
    image: shaurma,
    description: "Лаваш с говядиной, свежими овощами и классическими соусами"
  },
  {
    uid: "fastfood-6",
    id: 6,
    name: "Шаурма сырная",
    price: 250,
    image: shaurmaCheese,
    description: "Сырный лаваш с говядиной, овощами и нежным соусом с добавлением сыра"
  }
],
icecream: [
  {
    uid: "icecream-1",
    id: 1,
    name: "Рожок",
    price: 30,
    image: rojok,
    description: "Классическое мороженое в рожке"
  },
  {
    uid: "icecream-2",
    id: 2,
    name: "Стакан",
    image: stakan,
    price: 60,
    description: "Мороженое в стакане"
  },
  {
    uid: "icecream-3",
    id: 3,
    name: "Фруктовый",
    image: fruit,
    price: 150,
    description: "Мороженое с фруктами"
  }
],
cocktails: [
  {
    uid: "cocktail-1",
    id: 1,
    name: "Молочный",
    price: "20/30/50",
    description: "Классический молочный коктейль"
  },
  {
    uid: "cocktail-2",
    id: 2,
    name: "Клубничный",
    price: "50/70",
    description: "Клубничный молочный коктейль"
  },
  {
    uid: "cocktail-3",
    id: 3,
    name: "Шоколадный",
    price: "50/70",
    description: "Шоколадный молочный коктейль"
  },
  {
    uid: "cocktail-4",
    id: 4,
    name: "Банановый",
    price: "50/70",
    description: "Банановый молочный коктейль"
  },
  {
    uid: "cocktail-5",
    id: 5,
    name: "Карамельный",
    price: "50/70",
    description: "Карамельный молочный коктейль"
  }
],
sets: [
  {
    uid: "set-1",
    id: 1,
    name: "Love",
    description: "Филадельфия, Калифорния, Саки маки, Каппа маки",
    price: 850,
    image: love,
  },
  {
    uid: "set-2",
    id: 2,
    name: "Жара",
    description: "Фила темпура, Калифорния темпура, Чикен темпура",
    price: 1000,
    image: jara,
  },
  {
    uid: "set-3",
    id: 3,
    name: "Dos Pizza",
    description: "Пицца Верона, Запеченная Фила, Чикен хруст, Запеченный угорь + кола 1л",
    price: 1400,
    image: dospizza,
  },
  {
    uid: "set-4",
    id: 4,
    name: "Набор суши",
    description: "Запеченный угорь, Запеченный лосось, Запеченный краб, Запеченная курица, Суши лосось, Суши угорь (12 шт)",
    price: 800,
    image: nabor,
  },
  {
    uid: "set-5",
    id: 5,
    name: "Микс",
    description: "Фила, Угорь, Запеченная Фила, Калифорния темпура",
    price: 1100,
    image: mix,
  },
  {
    uid: "set-6",
    id: 6,
    name: "Три стихии",
    description: "Вулкан с лососем, Фила темпура, Пицца ассорти + кола 1л",
    price: 1200,
    image: threepoems,
  },
  {
    uid: "set-7",
    id: 7,
    name: "Идеальная пара",
    description: "Запеченный угорь, Чикен хруст, Фри, Сырный хлеб",
    price: 980,
    image: para,
  },
  {
    uid: "set-8",
    id: 8,
    name: "Мальчишник",
    description: "Чикен хруст, Чикен темпура, Запеченный угорь, Калифорния, Филадельфия, Суши лосось, Суши угорь, Пицца пепперони + кола 2л",
    price: 2300,
    image: malshish,
  },
],
burgers: [
  {
    uid: "burger-1",
    id: 1,
    name: "Классический",
    price: "180/210",
    description: "Булочки, говяжий фарш, помидор, огурцы, морковь, соус белый, кетчуп"
  },
  {
    uid: "burger-2",
    id: 2,
    name: "Чиккен бургер",
    price: "250/280",
    description: "Булочки, помидор, солёный огурец, морковь, куриное филе, сыр чеддер, чесночный соус, сырный соус"
  },
  {
    uid: "burger-3",
    id: 3,
    name: "Фиш бургер",
    price: "280/330",
    description: "Булочки, рыбная котлета, сыр чеддер, солёный огурец, морковь, помидор, капуста, сырный соус, соус барбекю"
  }
],
mojito: [
  {
    uid: "mojito-1",
    id: 1,
    name: "Океан",
    price: "100/150/250",
    description: "Освежающий напиток"
  },
  {
    uid: "mojito-2",
    id: 2,
    name: "Клубничный",
    price: "100/150/250",
    description: "Клубничный освежающий напиток"
  },
  {
    uid: "mojito-3",
    id: 3,
    name: "Малиновый",
    price: "100/150/250",
    description: "Малиновый освежающий напиток"
  },
  {
    uid: "mojito-4",
    id: 4,
    name: "Апельсиновый",
    price: "100/150/250",
    description: "Апельсиновый освежающий напиток"
  },
  {
    uid: "mojito-5",
    id: 5,
    name: "Лайм",
    price: "100/150/250",
    description: "Классический лаймовый напиток"
  },
  {
    uid: "mojito-6",
    id: 6,
    name: "Карамельный",
    price: "100/150/250",
    description: "Карамельный освежающий напиток"
  },
  {
    uid: "mojito-7",
    id: 7,
    name: "Тархун",
    price: "100/150/250",
    description: "Освежающий напиток со вкусом тархуна"
  },
  {
    uid: "mojito-8",
    id: 8,
    name: "Bubble Gum",
    price: "100/150/250",
    description: "Напиток со вкусом жвачки"
  }
],
  rolls: [
  {
    uid: "rolls-1",
    category: "cold",
    name: "Филадельфия",
    price: 350,
    image: fila,
    description: "Нежный ролл с лососем, сливочным сыром и свежим огурцом. Классика японской кухни с мягким и сбалансированным вкусом."
  },
  {
    uid: "rolls-2",
    category: "cold",
    name: "Фила угорь",
    price: 380,
    image: filaUgor,
    description: "Сытный ролл с копченым угрем, сливочным сыром и огурцом, дополненный ароматным соусом унаги и кунжутом."
  },
  {
    uid: "rolls-3",
    category: "cold",
    name: "Фила микс",
    price: 380,
    image: filaMiks,
    description: "Идеальное сочетание лосося и угря со сливочным сыром и огурцом. Богатый вкус для настоящих ценителей."
  },
  {
    uid: "rolls-4",
    category: "cold",
    name: "Калифорния",
    price: 350,
    image: kalifornia,
    description: "Легкий и популярный ролл с крабовыми палочками, огурцом и икрой масаго. Свежий и нежный вкус."
  },
  {
    uid: "rolls-5",
    category: "cold",
    name: "Калифорния с лососем",
    price: 380,
    image: kaliforniaSalmon,
    description: "Классическая калифорния с добавлением нежного лосося и сливочного сыра. Более насыщенный вкус."
  },

  // Hot Rolls
  {
    uid: "rolls-6",
    category: "hot",
    name: "Фила гриль",
    image: filaGril,
    price: 400,
    description: "Запеченный ролл с лососем под соусом унаги и кунжутом. Теплый, сочный и ароматный."
  },
  {
  uid: "roll-7",
  id: 7,
  name: "Фулкан с лососем",
    image: fulkan,
  price: 320,
  description: "Жареный ролл с лососем, сливочным сыром и огурцом, сверху икра масаго. Сытный, сочный и с лёгкой хрустящей корочкой.",
},
  {
    uid: "rolls-7",
    category: "hot",
    name: "Фила жаренная",
    image: salmonTempura,
    price: 330,
    description: "Хрустящий ролл в темпуре с нежным лососем и сливочным сыром. Снаружи хруст, внутри мягкость."
  },
  {
    uid: "rolls-8",
    category: "hot",
    name: "Калифорния жаренная",
    image: kaliforniaTempura,
    price: 330,
    description: "Калифорния в хрустящей темпуре с соусом унаги и кунжутом. Сытный и аппетитный вариант."
  },
  {
    uid: "rolls-9",
    category: "hot",
    name: "Чиккен темпура",
    image: chickenTempura,
    price: 330,
    description: "Горячий ролл с куриным филе в хрустящей темпуре, свежими овощами и соусом унаги."
  },
  {
    uid: "rolls-10",
    category: "hot",
    name: "Окинава",
    image: krabTempura,
    price: 360,
    description: "Сытный ролл с угрем и крабовыми палочками в темпуре, с ароматным соусом унаги."
  },

  // Baked Rolls
  {
    uid: "rolls-11",
    category: "baked",
    name: "Чиккен хруст",
    image: chickenxrust,
    price: 280,
    description: "Запеченный ролл с курицей, сливочным сыром и овощами, под соусами унаги и шрирача. Нежный внутри и слегка пикантный."
  },
  {
    uid: "rolls-12",
    category: "baked",
    name: "Запеченный ролл с угрем",
    price: 350,
      image: chickenzap,
    description: "Запеченный ролл с угрем, сливочным сыром и огурцом, покрытый соусом унаги и кунжутом."
  },
  {
    uid: "rolls-13",
    category: "baked",
    name: "Запеченная фила",
      image: chickenzap,
    price: 330,
    description: "Нежный запеченный ролл с лососем, сливочным сыром и тянущейся моцареллой."
  },
  {
    uid: "rolls-14",
    category: "baked",
    name: "Запеченный краб",
    price: 320,
      image: chickenzap,
    description: "Сытный ролл с курицей и крабовыми палочками под сырной шапкой и соусом унаги."
  },

  // Mini Rolls
  {
    uid: "rolls-15",
    category: "mini",
    name: "Саки маки",
    price: 180,
      image: minisalmon,
    description: "Мини ролл с нежным лососем. Легкий и классический вкус."
  },
  {
    uid: "rolls-16",
    category: "mini",
    name: "Саки унаги",
    price: 180,
      image: miniunagi,
    description: "Мини ролл с угрем и насыщенным вкусом соуса унаги."
  },
  {
    uid: "rolls-17",
    category: "mini",
    name: "Каппа маки",
      image: minicucumber,
    price: 100,
    description: "Свежий и легкий ролл с огурцом. Отлично подходит как дополнение."
  },

  // Sushi
  {
    uid: "rolls-18",
    category: "sushi",
    name: "Суши с лососем",
      image: sushisalmon,
    price: 80,
    description: "Классические суши с нежным ломтиком лосося на рисе."
  },
  {
    uid: "rolls-19",
    category: "sushi",
    name: "Суши с угрем",
      image: sushiunagi,
    price: 95,
    description: "Суши с угрем, соусом унаги и кунжутом. Насыщенный и сладковатый вкус."
  },
  {
    uid: "rolls-20",
    category: "sushi",
    name: "Запеченные суши (ассорти)",
    image: bakedSushi,
    price: 90,
    description: "Ассорти из запеченных суши с разными начинками: лосось, угорь, краб и курица."
  },

  // Sweet Rolls
  {
    uid: "rolls-21",
    category: "sweet",
    name: "Шокко ролл",
    image: sweetChoco,
    price: 250,
    description: "Сладкий ролл с бананом, сливочным сыром и шоколадным вкусом. Идеален на десерт."
  },
  {
    uid: "rolls-22",
    category: "sweet",
    name: "Минари",
    image: sweetBanana,
    price: 300,
    description: "Фруктовый ролл с бананом, киви, ананасом и апельсином под клубничным соусом."
  }
],

pizza: [
  {
    id: 1,
    name: "Верона",
     diameter: "34см",
    description: "Куриное филе, помидоры, грибы, сыр моцарелло, томатный соус",
    price: 450,
    image: veronaPizza
  },
  {
    id: 2,
    name: "Пеперони",
     diameter: "34см",
    description: "Колбаса, сыр моцарелло, томатный соус",
    price: 500,
    image: pepperoniPizza
  },
  {
    id: 3,
    name: "Ассорти",
     diameter: "34см",
    description: "Куриное филе, колбаса, говядина фарш, томатный соус, сыр моцарелло",
    price: 450,
    image: assortiPizza
  },
  {
    id: 4,
    name: "Цезарь",
     diameter: "34см",
    description: "Куриное филе, капуста, белый соус, сыр моцарелло",
    price: 450,
    image: caesarPizza
  },
  {
    id: 5,
    name: "Мясная",
    description: "Говядина фарш, томатный соус, сыр моцарелло",
    diameter: "34см",
    price: 450,
    image: meatPizza
  }
],


snacks: [
  { uid: "snacks-1", id: 1, name: "Чесночный хлеб", price: 120, image: garlic },

{ 
  uid: "snacks-2",
  id: 2,
  name: "Стрипсы",
  price: "10 шт — 280 сом",
  image: strips
},

  { uid: "snacks-3", id: 3, name: "Нагетсы", price: 250, image: naggets },
{ 
  uid: "snacks-4",
  id: 4,
  name: "Крылышки",
price: `6 шт — 300 сом<br>10 шт — 450 сом<br>20 шт — 800 сом`,
  image: wings
},

  { uid: "snacks-5", id: 5, name: "Фри", price: 150, image: fri },

  { uid: "snacks-6", id: 6, name: "По деревенский", price: 150, image: potatoVillage },

  { uid: "snacks-7", id: 7, name: "Сырные шарики", price: 150, image: cheeseBalls },
],

milkshakes: [

  { uid: "milkshakes-2", id: 2, name: "Шоколадный", price: "0.5л — 250 сом<br>0.7л — 290 сом", image: chocolateMilkshake, description: "Классический густой милкшейк с насыщенным шоколадным вкусом." },

  { uid: "milkshakes-3", id: 3, name: "Ананасовый", price: "0.5л — 250 сом<br>0.7л — 290 сом", image: pineappleMilkshake, description: "Свежий и тропический вкус спелого ананаса — лёгкий и освежающий." },

  { uid: "milkshakes-4", id: 4, name: "Орео", price: "0.5л — 250 сом<br>0.7л — 290 сом", image: oreoMilkshake, description: "Сливочный милкшейк с кусочками Oreo — сладкий и густой." },

  { uid: "milkshakes-5", id: 5, name: "Клубничный", price: "0.5л — 250 сом<br>0.7л — 290 сом", image: strawberryMilkshake, description: "Нежный клубничный милкшейк с мягким ягодным вкусом." },

  { uid: "milkshakes-6", id: 6, name: "Чёрная смородина", price: "0.5л — 250 сом<br>0.7л — 290 сом", image: blackberryMilkshake, description: "Яркий вкус чёрной смородины, слегка кисло-сладкий и освежающий." }
],

  soups: [
    { uid: "soups-1", id: 1, name: "Том Ям (курица)", price: 65000, description: "Том Ям с курицей – классический тайский остро-кислый суп с нежной курицей, лимонной травой, галангалом и лаймом. Яркий вкус и аромат, который согревает и бодрит.", image: salmonTomYamImg },
    { uid: "soups-2", id: 2, name: "Том Ям (сёмга)", price: 70000, description: "Том Ям Сёмга – ароматный тайский суп с нежной сёмгой, острыми специями, лимонной травой и лаймом. Идеальный баланс остроты, кислинки и свежести.", image: salmonTomYamImg },

    // id=3 повторяется — оставил, но uid уникальный
    { uid: "soups-3", id: 3, name: "Рамен c курицей", price: 45000, image: spicyRamen, description: "Острый Рамен с курицей – горячий пряный бульон с нежной курицей, варёным яйцом и ароматом соевого соуса." },
    { uid: "soups-3b", id: 3, name: "Рамен сырный", price: 55000, image: chesseRamen, description: "Сырный Рамен с курицей – сливочный бульон с нежной курицей, варёным яйцом, плавленым сыром и чеддером. Нежно, сытно и ароматно." },
  ],

  drinks: [
 {
    uid: "mojito-1",
    id: 1,
    name: "Мохито классический",
    price: "0.5л — 100 сом<br>0.7л — 150 сом",
    image: mojitoClassic,
  },
  {
    uid: "mojito-2",
    id: 2,
    name: "Мохито клубничный",
    price: "0.5л — 100 сом<br>0.7л — 150 сом",
    image: mojitoStrawberry,
  },
  {
    uid: "mojito-3",
    id: 3,
    name: "Мохито ананасовый",
    price: "0.5л — 100 сом<br>0.7л — 150 сом",
    image: mojitoPineapple,
  },
  {
    uid: "mojito-4",
    id: 4,
    name: "Мохито чёрная смородина",
    price: "0.5л — 100 сом<br>0.7л — 150 сом",
    image: mojitoBlackcurrant,
  },
   { 
    uid: "drinks-1",
    id: 1,
    name: "Бабл ти карамель",
    price: "0.5л — 250 сом<br>0.7л — 290 сом",
    image: caramelBubble
  },
  { 
    uid: "drinks-2",
    id: 2,
    name: "Бабл ти клубника",
    price: "0.5л — 250 сом<br>0.7л — 290 сом",
    image: strawberryBubble
  },
  { 
    uid: "drinks-3",
    id: 3,
    name: "Бабл ти смородина",
    price: "0.5л — 250 сом<br>0.7л — 290 сом",
    image: blackberryBubble
  },
    { 
    uid: "drinks-3",
    id: 3,
    name: "Бабл ти ананас",
    price: "0.5л — 250 сом<br>0.7л — 290 сом",
    image: pineappleBubble
  },
  ],


 wok: [
  { uid: "wok-2", id: 2, image: sobaChicken, name: "Соба с курицей", price: 330 },
  { uid: "wok-3", id: 3, image: sobaSalmon, name: "Соба с лососем", price: 380 },
  { uid: "wok-5", id: 5, image: udonChicken, name: "Удон с курицей", price: 310 },
  { uid: "wok-6", id: 6, image: udonSalmon, name: "Удон с лососем", price: 360 },
],

tea: [
  { uid: "tea-1", id: 1, name: "Чай обычный", price: 20, image: simpleTea },
  { uid: "tea-2", id: 2, name: "Чай с лимоном", price: 80, image: lemonTea },
  { uid: "tea-3", id: 3, name: "Чай с мятой", price: 80, image: mintTea },

  { uid: "tea-4", id: 4, name: "Чай Каркаде", price: 150, image: karkadeTea },
  { uid: "tea-5", id: 5, name: "Чай ягодный", price: 150, image: strawberryTea },
  { uid: "tea-6", id: 6, name: "Чай имбирный", price: 150, image: gingerTea },
  { uid: "tea-7", id: 7, name: "Чай черная смородина", price: 150, image: blackberryTea },
  { uid: "tea-8", id: 8, name: "Ананасовый чай", price: 150, image: pineappleTea },
  { uid: "tea-9", id: 9, name: "Ташкентский чай", price: 150, image: tashkentTea },
],
  // coffee: [
  //   { uid: "coffee-1", id: 1, name: "Американо", price: 15000 },
  //   { uid: "coffee-2", id: 2, name: "Латте", price: 18000 },
  //   { uid: "coffee-2b", id: 2, name: "Капучино", price: 18000 },
  // ],
}
